<template>
  <div class="appeal" :style="(currentIndex != 0 && !$isFlag) ? 'background:#fff' : ''">
    <header-item
      :title-array="titleArray"
      :is-show="true"
      :title-mb="titleArray[0]"
      type-next="click"
      @navBarClick="navBarClick"
    />
    <!-- 选择申诉 -->
    <div v-if="currentIndex == 0" class="formClass">
      <div class="auth">
        <div class="name" @click="accountClick">
          <img src="~assets/images/accountCenter/24.png" alt="">
          <div class="text">
            <p>自助保护性冻结</p>
            <p>如果账号被盗/被骗可以自助冻结账号保障财产安全</p>
          </div>
        </div>
        <div class="name" @click="gameClick">
          <img src="~assets/images/accountCenter/26.png" alt="">
          <div class="text">
            <p>解除保护性冻结</p>
            <p>账号通过申诉确保安全之后可以自助解除保护性冻结</p>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import headerItem from '@/views/accountCenter/common/header'

export default {
  name: 'Appeal',
  components: {
    headerItem
  },
  data() {
    return {
      currentIndex: 0,
      preIndex: [],
      titleArray: ['选择类型', '首页', '账号自助管理', '解冻冻结'],
      backFlag: true
    }
  },
  watch: {
    currentIndex(newVal, oldVal) {
      console.log(newVal, 'currentIndex', oldVal, '上个index')
      if (this.$isFlag) {
        window.scrollTo(0, 0)
      }
      if (this.backFlag) {
        this.preIndex.push(oldVal)
      }
    }
  },
  created() {
    console.log(this.$route.query)
    if (this.$route.query.stateKey) {
      this.currentIndex = Number(this.$route.query.stateKey) || 0
    }
  },
  mounted() {
    if (this.$isFlag) {
      document.querySelector('.appeal').className = ['appeal accountAppealH5 accountCommonH5']
    } else {
      document.querySelector('.appeal').className = ['appeal accountAppealWeb accountCommonWeb']
    }
  },
  methods: {
    navBarClick() {
      this.backFlag = false
      if (this.preIndex.length != 0) {
        this.currentIndex = this.preIndex.pop()
      } else {
        this.$router.go(-1)
      }
    },
    gameClick() {
      // window.open('https://helper.leiting.com/SelfProtectiveOp/account_protection/unfreeze.do')
      this.$ssd.track('leiting_accountcenter_nofreeze')
      this.$router.push('/accountCenter/accountSelf/accountProtectUnfreeze')
    },
    accountClick() {
      this.$ssd.track('leiting_accountcenter_freeze')
      // window.open('https://helper.leiting.com/SelfProtectiveOp/account_protection/freeze.do')
      this.$router.push('/accountCenter/accountSelf/accountProtectFreeze')
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~assets/css/accountCommon.styl';

</style>
<style lang="stylus" scoped>
@import '~assets/css/accountCenter/accountAppeal.styl';

// web
  .accountAppealWeb {
    .name {
      cursor pointer
    }
  }
</style>
